import './App.css';
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";
import './App.css';
import AddAdmin from './pages/AddAdmin';
import StatisticsScreen from './pages/StatisticsScreen';
import {ThemeProvider} from "styled-components";
import { GlobalStyles } from "../src/components/globalStyles";
import { lightTheme, darkTheme } from "../src/components/Themes"
import { useState } from 'react';
import {ThemeContext} from './context/ThemeContext'
import Home from './pages/Home'
import Profile from './pages/Profile'
import Setting from './pages/Setting'
import ChatScreen from './pages/ChatScreen'
import ChatScreenMobo from './pages/ChatScreenMobo'
import Events from './pages/Events'
import ProductListScreen from './pages/ProductListScreen'
import ProductScreen from './pages/ProductScreen'
import Notification from './pages/NotificationScreen'
import Help from './pages/Help'
import ProductDetail from './pages/ProductDetail';
import LoginScreen from './pages/LoginScreen';
import SignupScreen from './pages/SignupScreen';
import LikesScreen from './pages/LikesScreen';
import Blog from './pages/Blog';
import ResetPassword from './pages/ResetPassword';
import CategoryListView from './pages/CategoryListView';
import HorizontalOptionBar from './components/HorizontalOptionBar';
import NavBar from './components/NavBar';



function App() {
  const [theme, setTheme] = useState('dark')

  return (
    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <GlobalStyles/>
    <ThemeContext.Provider value={{theme, setTheme}}>
   
    <BrowserRouter>
    <NavBar/>
    <HorizontalOptionBar/>
    <Routes>
      <Route path="/" element={ <Home/>} />
      <Route path="/login" element={ <LoginScreen/>} />
      <Route path="/signup" element={ <SignupScreen/>} />
      <Route path="/admin" element={<AddAdmin />} />
      <Route path="/stats" element={<StatisticsScreen />} />
      <Route path="/events" element={<Events/>}/>
      <Route path="/help" element={<Help/>} />
      <Route path="/chat/:uid" element={<ChatScreen/>} />
      <Route path="/chatm/:uid" element={<ChatScreenMobo/>} />
      <Route path="/notification" element={<Notification/> } />
      <Route path="/profile" element={<Profile/>} />
      <Route path="/productlist/:subcategory" element={<ProductListScreen/>} />
      <Route path="/product" element={<ProductScreen/> } />
      <Route path="/productdetail/:productId" element={<ProductDetail /> } />
      <Route path="/setting" element={<Setting/>} />
      <Route path="/likes" element={<LikesScreen/>} />
    <Route path="/blog" element={<Blog/>} />
    <Route path="/reset-password" element={<ResetPassword/>} />
    <Route path="/view-list" element={<CategoryListView/>} />
    </Routes>
  </BrowserRouter>
    </ThemeContext.Provider>
      </ThemeProvider>
  );
}

export default App;
